<template>
    <v-card
        class="default_card large mx-0 my-2 pa-2"
        elevation="0"
        v-if="resourceAllocations && resourceAllocations.length"
    >
        <v-row no-gutters class="d-flex align-center justify-space-between">
            <v-col cols="2" class="pb-2">
                <h2>{{ resourceAllocationTitle }}</h2>
            </v-col>
            <v-col cols="3" class="pb-2 pl-2">
                <v-select-filled
                    v-model="resourceAllocationPeriod"
                    :items="resourceAllocationPeriods"
                    hide-details="auto"
                    label="Période"
                />
            </v-col>
            <v-spacer />
            <v-col cols="1" class="pb-2 pl-2">
                <v-btn
                    size="small"
                    @click="openEditionDialog(false)"
                    :disabled="!!!filteredProductTags && !!!filteredProductTags.length"
                >
                    {{ "Ajouter" }}
                </v-btn>
            </v-col>
        </v-row>
        <!-- <v-row no-gutters v-for="(cropRotation, index) in cropRotations" :key="index">
            {{cropRotation.name + " - " + cropRotation.surface + " ha - " + cropRotation.yield + " T/ha"}}
        </v-row> -->
        <v-row no-gutters v-if="resourceAllocations && resourceAllocations.length">
            <v-col cols="3" class="text-h6"> Ressource </v-col>
            <v-col cols="2" class="text-h6"> Surface </v-col>
            <v-col cols="2" class="text-h6"> Rendement </v-col>
        </v-row>
        <v-row
            no-gutters
            v-for="(resourceAllocation, index) in filteredResourceAllocations"
            :key="index"
            class="pb-1"
        >
            <v-col cols="3" style="align-content: center">
                {{ resourceAllocation.name }}
            </v-col>
            <v-col cols="2" style="align-content: center">
                {{ getSymbolText(resourceAllocation) }}
            </v-col>
            <v-col cols="2" style="align-content: center">
                {{ getYieldText(resourceAllocation, resourceAllocation.productQuantityType) }}
            </v-col>
            <v-col cols="1">
                <v-btn-icon
                    icon="$oss-edit"
                    density="compact"
                    size="small"
                    color="secondary"
                    @click="openEditionDialog(true)"
                />
                <!-- <v-btn
                    dense
                    icon
                     size="small"
                    color="primary"
                    @click="true"
                >
                    <v-icon  size="small">$oss-duplicate</v-icon>
                </v-btn> -->
            </v-col>
        </v-row>
        <oss-dialog
            v-model="editDialog"
            :valid-disabled="disableValidate()"
            title="Répartition"
            :valid-title="editionAllocations.length ? 'Modifier' : 'Créer'"
            @valid="valid()"
            @close="close()"
            :validLoading="loading"
            width="80vw"
        >
            <v-container class="px-6 pb-6">
                <v-row no-gutters>
                    <v-col cols="1" class="pl-2" style="align-content: center"> Période : </v-col>
                    <v-col cols="3" class="pr-2">
                        <oss-date-picker-filled
                            v-model="startDate"
                            label="Date de début"
                            :textFieldReadOnly="false"
                            hide-details
                        />
                    </v-col>
                    <v-col cols="3">
                        <oss-date-picker-filled
                            v-model="endDate"
                            label="Date de fin"
                            :textFieldReadOnly="false"
                            hide-details
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <oss-data-table
                        :headers="headers"
                        :items="editionAllocations"
                        class="table"
                        fixed-header
                        :fixed-footer="true"
                        max-height="60vh"
                        :hide-default-footer="true"
                    >
                        <template v-slot:item="{ item, index }">
                            <tr>
                                <td class="text-left">{{ item.name }}</td>
                                <td class="text-left">
                                    <v-row no-gutters class="align-center">
                                        <v-col>
                                            <oss-text-field-filled
                                                v-model="item.production"
                                                class="custom-text-field"
                                                hide-details
                                            />
                                        </v-col>
                                        <v-col>
                                            <v-select-filled
                                                v-model="item.resourceQuantityType"
                                                :items="quantityTypes"
                                                item-value="value"
                                                class="pl-2 mt-0"
                                                :item-title="(item) => item.text"
                                            />
                                        </v-col>
                                    </v-row>
                                </td>
                                <td class="text-center">{{ getSymbolText(item) }}</td>
                                <td class="text-left">
                                    <v-row no-gutters class="align-center">
                                        <v-col cols="5">
                                            <v-select-filled
                                                v-model="item.productUnitQuantity"
                                                :items="getQuantityValues(item.productQuantityType)"
                                                item-value="value"
                                                class="mt-0"
                                                :item-title="(item) => item.symbol"
                                            />
                                        </v-col>
                                        <v-col cols="7">
                                            <v-select-filled
                                                v-model="item.productQuantityType"
                                                :items="quantityTypes"
                                                item-value="value"
                                                class="pl-2 mt-0"
                                                @update:model-value="item.productUnitQuantity = 1"
                                                :item-title="(item) => item.text"
                                            />
                                        </v-col>
                                    </v-row>
                                </td>
                                <td>
                                    <oss-text-field-filled
                                        v-model="item.yield"
                                        rounded
                                        class="custom-text-field"
                                        hide-details
                                    />
                                </td>
                                <td class="text-center">
                                    {{ getYieldText(item, item.productQuantityType) }}
                                </td>
                                <td class="text-center">
                                    <v-btn-trash
                                        size="x-small"
                                        @click="deleteAllocation(item.id, index)"
                                    />
                                </td>
                            </tr>
                        </template>
                        <template v-slot:body.append>
                            <tr>
                                <td colspan="2" />
                                <td class="text-right">Ajouter :</td>
                                <td class="text-left" colspan="3">
                                    <v-select-filled
                                        outlined
                                        v-model="selectedProduct"
                                        :items="filteredProductTags"
                                        item-value="id"
                                        return-object
                                        class="mt-0"
                                        dense
                                        hide-details
                                        :item-title="(item) => item.name"
                                    />
                                </td>
                                <td class="text-center">
                                    <v-btn-icon
                                        color="secondary"
                                        size="x-small"
                                        variant="flat"
                                        elevation="0"
                                        :disabled="!selectedProduct.id"
                                        @click="pushNewAllocation()"
                                        icon="$add"
                                    />
                                </td>
                            </tr>
                        </template>
                    </oss-data-table>
                </v-row>
            </v-container>
        </oss-dialog>
    </v-card>
</template>

<script lang="ts">
import gql from "graphql-tag";
import moment from "moment-timezone";
import _ from "lodash";
import { Apollo } from "../decorators";
import { Component, Vue, Watch, Prop, toNative } from "vue-facing-decorator";
import { DialogAction } from "../services/dialogAction";

import UPSERT_RESOURCE_ALLOCATIONS from "../graphql/stock/UpsertResourceAllocations.gql";

import {
    getSymbolData,
    quantityTypeSymbols,
    quantityTypes,
} from "../../../backend/src/common/stock/invoiceProductServices";
import { getDBFormattedEndDate, getDBFormattedStartDate } from "../services/dateServices";
import OssDataTable from "./ossComponents/ossDataTable2.vue";

@Component({
    components: {
        OssDataTable,
    },
})
export class ResourceAllocationEdition extends Vue {
    @Prop() companyId;

    actions = {
        action: new DialogAction(),
    };

    loading: boolean = false;

    startDate = "";
    endDate = "";

    toDeleteIds = [];
    editionAllocations = [];

    defaultNewAllocation = {
        id: "",
        name: "",
        startDate: "",
        endDate: "",
        productTag: { id: "", name: "", partitionTag: { id: "" } },
        yield: 0,
        resourceQuantityType: "QUANTITY",
        resourceUnitQuantity: 1,
        resourceQuantity: 1,
        resourceQuantityName: "",
        productQuantityType: "QUANTITY",
        productUnitQuantity: 1,
        productQuantityName: "",
        production: 1000,
        key: "",
    };

    defaultSelectedProduct = {
        id: "",
        name: "",
        partitionTag: { id: "" },
    };

    selectedProduct = {
        id: "",
        name: "",
        partitionTag: { id: "" },
    };

    headers = [
        { text: "Ressource", value: "name", align: "left", width: "15%" },
        { text: "Metrique spatiale", value: "resourceQuantity", align: "center", width: "30%" },
        { text: "Affichage", value: "symbol1", align: "center", width: "10%" },
        { text: "Mesure de production", value: "prod", align: "center" },
        { text: "Rendement", value: "yield", align: "center" },
        { text: "Affichage", value: "symbol2", align: "center", width: "10%" },
    ];

    get quantityTypes() {
        return quantityTypes;
    }

    get quantityTypeSymbols() {
        return quantityTypeSymbols;
    }

    getQuantityValues(type) {
        if (type === "QUANTITY") {
            return [{ value: 1, symbol: "-" }];
        }
        return this.quantityTypeSymbols[type];
    }

    get resourceAllocationTitle() {
        return "Assolement";
    }

    editDialog = false;

    resourceAllocationPeriod = "";

    get resourceAllocationPeriods() {
        const periods = [];
        for (const ra of this.resourceAllocations) {
            if (periods.indexOf(ra.key) === -1) {
                periods.push(ra.key);
            }
        }
        return periods;
    }

    getSymbolData(product) {
        const productIndexed = {
            quantityName: "",
            quantityType: product.resourceQuantityType || "QUANTITY",
            unitQuantity: product.production,
        };
        const data = getSymbolData(productIndexed);
        product.resourceUnitQuantity = data.symbolValue ? data.symbolValue : 1;
        product.resourceQuantity = data.value;
        return data;
    }

    getSymbolText(product) {
        return this.getSymbolData(product).text;
    }

    getUnitQuantity(product) {
        return this.getSymbolData(product).value;
    }

    getYieldText(product, type) {
        let productText;
        if (type === "QUANTITY") {
            productText = product.yield > 1 ? "unités" : "unité";
        } else {
            productText = this.quantityTypeSymbols[type].find(
                (i) => i.value === product.productUnitQuantity,
            ).symbol;
        }
        const resourceText = this.getSymbolText(product);
        return `${product.yield} ${productText}/${resourceText.split(" ")[1]}`;
    }

    @Apollo({
        query: gql`
            query ResourceAllocations($companyId: ID!) {
                resourceAllocations(where: { company: { id: $companyId } }) {
                    id
                    name

                    startDate
                    endDate

                    productTag {
                        id
                        name
                        partitionTag {
                            id
                        }
                    }

                    yield

                    resourceQuantityType
                    resourceUnitQuantity
                    resourceQuantity
                    resourceQuantityName

                    productQuantityType
                    productUnitQuantity
                    productQuantityName
                }
            }
        `,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.resourceAllocations) {
                    for (const ra of data.resourceAllocations) {
                        ra.key =
                            (ra.startDate ? moment(ra.startDate).format("DD/MM/YYYY") : "XXX") +
                            " - " +
                            (ra.endDate ? moment(ra.endDate).format("DD/MM/YYYY") : "XXX");
                        ra.production =
                            Math.round(ra.resourceQuantity * ra.resourceUnitQuantity * 1000) / 1000;
                    }
                    this.resourceAllocations = data.resourceAllocations;
                    if (this.resourceAllocations.length) {
                        const momentDates = this.resourceAllocations.map((ra) =>
                            moment(ra.endDate),
                        );
                        const latestDate = moment.max(momentDates);
                        // Find the index of the latest end date in the original array
                        let latestIndex = momentDates.findIndex((date) => date.isSame(latestDate));
                        if (latestIndex < 0) {
                            latestIndex = this.resourceAllocations.length - 1;
                        }
                        this.resourceAllocationPeriod = this.resourceAllocations[latestIndex].key;
                    }
                }
            }
        },
    })
    resourceAllocations = [];

    get filteredResourceAllocations() {
        if (this.resourceAllocations.length) {
            return this.resourceAllocations.filter(
                (ra) => ra.key === this.resourceAllocationPeriod,
            );
        }
        return [];
    }

    @Apollo({
        query: gql`
            query Products($companyId: ID!) {
                invoiceProducts(
                    where: {
                        company: { id: $companyId }
                        stock: true
                        outDated_not: true
                        tag: { id_not: "" }
                        type: PRODUCT
                    }
                ) {
                    id
                    title
                    tag {
                        id
                        name
                        partitionTag {
                            id
                        }
                    }
                }
            }
        `,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (data && data.invoiceProducts?.length) {
                this.productTags = data.invoiceProducts.map((ip) => {
                    if (ip.tag?.id) {
                        return {
                            id: ip.tag.id,
                            name: ip.tag.name,
                            partitionTag: ip.tag.partitionTag,
                        };
                    }
                });
            }
        },
    })
    productTags = [];

    get filteredProductTags() {
        if (this.productTags.length) {
            return this.productTags.filter(
                (tag) => !this.editionAllocations.some((ra) => ra.productTag.id === tag.id),
            );
        }
        return [];
    }

    openEditionDialog(withDates) {
        this.startDate = "";
        this.endDate = "";
        if (withDates) {
            const [startDate, endDate] = this.resourceAllocationPeriod.split(" - ");
            this.startDate = this.formatDateForOssDatePicker(startDate);
            this.endDate = this.formatDateForOssDatePicker(endDate);
            this.editionAllocations = _.cloneDeep(this.filteredResourceAllocations);
        } else {
            this.editionAllocations = [];
        }
        this.editDialog = true;
    }

    pushNewAllocation() {
        const newAllocation = JSON.parse(JSON.stringify(this.defaultNewAllocation));
        newAllocation.id = "";
        newAllocation.name = this.selectedProduct.name;
        newAllocation.productTag = this.selectedProduct;
        newAllocation.productTag.partitionTag = this.selectedProduct.partitionTag;
        this.editionAllocations.push(newAllocation);
        this.selectedProduct = JSON.parse(JSON.stringify(this.defaultSelectedProduct));
    }

    deleteAllocation(itemId, i) {
        if (itemId) {
            this.toDeleteIds.push(itemId);
        }
        this.editionAllocations.splice(i, 1);
    }

    async valid() {
        for (const ra of this.editionAllocations) {
            ra.startDate = getDBFormattedStartDate(this.startDate);
            ra.endDate = getDBFormattedEndDate(this.endDate);
        }
        this.loading = true;
        const result = await this.$apollo.mutate({
            mutation: UPSERT_RESOURCE_ALLOCATIONS,
            variables: {
                companyId: this.companyId,
                toDeleteAllocations: this.toDeleteIds,
                resourceAllocations: this.editionAllocations,
            },
        });
        if (result.data.upsertResourceAllocations.success) {
            this.loading = false;
            this.refresh();
        }
        this.startDate = "";
        this.endDate = "";
        this.editDialog = false;
    }

    disableValidate() {
        if (!this.startDate || !this.endDate) {
            return true;
        }
    }

    close() {
        this.editionAllocations = [];
    }

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.resourceAllocations) {
            this.$apollo.queries.resourceAllocations.refetch();
        }
    }

    formatDateForOssDatePicker(date) {
        if (!date) return null;
        return moment(date, "DD/MM/YYYY").format("MM/DD/YYYY");
    }
}

export default toNative(ResourceAllocationEdition);
</script>
